import { Component } from 'react'
import { gql } from "@apollo/client"
import { Col, Row, Input } from 'reactstrap'
import ListingFilters from "../Material/ListingFilters"
import renderEnumToInt from '../Functions/renderEnumToInt'
import toTitleCase from '../Functions/toTitleCase'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { LEGACY_SYSTEM_OPTIONS } from '../Constants'

const AllIncidentTypesQuery = gql`query AllIncidentTypesQuery{
    optionsList: __type(name: "IncidentsIncidentIncidentTypeChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const CarTotaledOptionsQuery = gql`query CarTotaledOptionsQuery {
  optionsList: __type(name: "IncidentsIncidentCarTotaledChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const StatusOptionsQuery = gql`query StatusOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentStatusChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const SourceOptionsQuery = gql`query SourceOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentSourceChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const ReportedByOptionsQuery = gql`query ReportedByOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentReportedByChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const ResponsiblePartyOptionsQuery = gql`query ResponsiblePartyOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentResponsiblePartyChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const RidesharePlatformOptionsQuery = gql`query RidesharePlatformOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentRidesharePlatformChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const RidesharePeriodOptionsQuery = gql`query RidesharePeriodOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentRidesharePeriodChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const RidesharePeriodSourceOptionsQuery = gql`query RidesharePeriodSourceOptionsQuery {
    optionsList: __type(name: "IncidentsIncidentRidesharePeriodSourceChoices") {
        states:enumValues {
            name
            description
        }
    }
}`

const RepsQuery = gql`
     query AllRepsQuery($groups:[String], $orderBy:[String]){
        optionsList: allReps(isStaff:true, isActive:true, groups:$groups, orderBy:$orderBy){
        edges{
          node{
            id
            name
            username
            firstName
            lastName
            email
            isBilling
            isFrontOffice
            assignedCount
          }
        }
      }
    }
`
const AllBranchesQuery = gql`query AllBranchesQuery {
    optionsList: allBranches(isUserScoped:true) {
        edges {
            node {
                id
                name
            }
        }
    }
}`
const AllLineOfBusinessQuery = gql`query AllLineOfBusiness {
    optionsList: allLineOfBusiness {
        edges {
            node {
                id
                name
            }
        }
    }
}`

class IncidentListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
        }
    }

    getFilterConfigurations = (activeTab) => {
        return [
            { type: "text", name: "searchTerm", title: "Search Term", placeholder: "Search By Name, TLC, Phone", showFilter: false },
            { type: "number", name: "incidentPk", title: "Incident ID", placeholder: "1234", showFilter: true },
            { type: "number", name: "driverPk", title: "Driver ID", placeholder: "1234", showFilter: true },
            { type: "select", name: "incidentTypes", title: "Incident Types", placeholder: "Filter By Incident Types", optionsQuery: AllIncidentTypesQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "statuses", title: "Statuses", placeholder: "Filter By Status", optionsQuery: StatusOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "boolean", name: "incidentDateIsNull", title: "Incident Date Is Null", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Incident Date Is Null", showFilter: true },
            { type: "boolean", name: "withoutRental", title: "Without Rental", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Without Rental", showFilter: true },
            { type: "select", name: "carTotaled", title: "Is Car Totaled", placeholder: "Filter By Incident Types", optionsQuery: CarTotaledOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true },
            { type: "boolean", name: "isArchived", title: "Is Archived", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Archived", showFilter: true },
            { type: "boolean", name: "hasLiabilityClaim", title: "Has Liability Claim", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Has Liability Claim", showFilter: true },
            { type: "boolean", name: "hasSubroClaim", title: "Has Subro Claim", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Has Subro Claim", showFilter: true },
            { type: "boolean", name: "liabilityClaimExists", title: "Liability Claim Exists", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Liability Claim Exists", showFilter: true },
            { type: "boolean", name: "subroClaimExists", title: "Subro Claim Exists", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Subro Claim Exists", showFilter: true },
            { type: "boolean", name: "carOnHold", title: "Is Car on Hold", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Car on Hold", showFilter: true },
            { type: "boolean", name: "activeDrivers", title: "Active Drivers", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Active Drivers", showFilter: true },
            { type: "boolean", name: "hasIncompleteReturn", title: "Has Incomplete Return", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Has Incomplete Return", showFilter: true },
            { type: "boolean", name: "hasUnauthorizedDrivers", title: "Has Unauthorized Drivers", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Has Unauthorized Drivers", showFilter: true },
            { type: "select", name: "sources", title: "Sources", placeholder: "Filter By Sources", optionsQuery: SourceOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "reportedBy", title: "Reported By", placeholder: "Filter By Reported By", optionsQuery: ReportedByOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "responsibleParties", title: "Responsible Parties", placeholder: "Filter By Responsible Party", optionsQuery: ResponsiblePartyOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "ridesharePlatforms", title: "Rideshare Platforms", placeholder: "Filter By Rideshare Platform", optionsQuery: RidesharePlatformOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "ridesharePeriods", title: "Rideshare Periods", placeholder: "Filter By Rideshare Period", optionsQuery: RidesharePeriodOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "ridesharePeriodSources", title: "Rideshare Period Sources", placeholder: "Filter By Rideshare Period Source", optionsQuery: RidesharePeriodSourceOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true, isMulti: true },
            { type: "select", name: "externalIdKeys", title: "Legacy Systems", placeholder: "Filter By Legacy Systems", options: LEGACY_SYSTEM_OPTIONS, showFilter: true, isMulti: true },
            { type: "select", name: "assignedTo", title: "Assigned Reps", valueSelector: "id", labelSelector: "name", optionsQuery: RepsQuery, variables: [{ groups: ["FNOL"] }], placeholder: "Filter By Assigned Reps", showFilter: activeTab === "#all", isMulti: true },
            { type: "select", name: "incidentBranchIds", title: "Branches", placeholder: "Filter By Branches", optionsQuery: AllBranchesQuery, valueSelector: "id", labelSelector: "name", showFilter: true, isMulti: true },
            { type: "select", name: "lineOfBusinessIds", title: "Line Of Business", placeholder: "Filter By Line Of Business", optionsQuery: AllLineOfBusinessQuery, valueSelector: "id", labelSelector: "name", showFilter: true, isMulti: true },
            { type: "date", name: "incidentDate", title: "Incident Date", placeholder: "Filter By Incident Date", showFilter: true },
            { type: "dateRange", name: "dateAdded", title: "Date Added", showFilter: true },
        ]
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    removeFilter = (filterName) => {
        let filterValues = this.props.filterValues
        let filterKeys = Object.keys(filterValues)
        if (filterKeys.includes(filterName)) {
            delete filterValues[filterName]
            this.props.setFilterValues({ ...this.props.filterValues })
        }
    }
    getValueByFilterType = (filterConfigs, value) => {
        if (filterConfigs.type === "select") {
            let options = filterConfigs["options"]
            if (options && options.length > 0) {
                if (Array.isArray(value)) {
                    value = value.map(item => options.find(option => option.value == item).label)
                } else {
                    if (value === true) {
                        value = 'true'
                    }
                    else if (value === false) {
                        value = 'false'
                    }
                    value = options.find(option => option.value == value) && options.find(option => option.value == value).label
                }
            }
        } else if (filterConfigs.type === "boolean")
            value = toTitleCase(value.toString())
        else if (filterConfigs.type === "dateRange" || filterConfigs.type === "dateTimeRange") {
            if (!value?.start && !value?.end) return ""
            const start = value.start ? value.start : ""
            const end = value.end ? value.end : ""
            return `${start} → ${end}`
        }

        return Array.isArray(value) ? value.join(", ") : value
    }

    setFilters = () => {
        let conf = this.getFilterConfigurations(this.props.activeTab)
        let configurations = conf.filter(filter => filter['showFilter']).map(filter => {
            if (filter['optionsQuery']) {
                let options = []
                this.props?.apolloClient?.query({
                    query: filter.optionsQuery,
                    variables: { ...filter.variables }
                }).then(result => {
                    if (result && result.data.optionsList && result.data.optionsList.edges && result.data.optionsList.edges.length > 0) {
                        options = result.data.optionsList.edges.map(options => options.node && ({ value: options.node[filter.valueSelector], label: options.node[filter.labelSelector] }))
                    }
                    else if (result && result.data.optionsList && result.data.optionsList.states && result.data.optionsList.states.length > 0) {
                        options = result.data.optionsList.states.map(options => options.node ? ({ value: options.node[filter.valueSelector], label: options.node[filter.labelSelector] }) : ({ value: filter.extractValue ? renderEnumToInt(options[filter.valueSelector]) : options[filter.valueSelector], label: options[filter.labelSelector] }))
                    }
                    filter['options'] = options
                    delete filter['optionsQuery']
                })
            }
            return filter
        })
        this.setState({ configurations: configurations })
    }

    getFiltersLength = () => {
        let keys = Object.keys(this.props.filterValues)
        let filtersValue = keys.filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).length
        return filtersValue ? ` | ${filtersValue}` : ""
    }

    componentDidMount() {
        this.setFilters()
    }

    render() {
        return (
            <Row className="pb-2">
                {this.state.openModal === "viewFilters" &&
                    <ListingFilters open={this.state.openModal === "viewFilters"} handleClose={() => this.toggleModal("")}
                        target="viewFilters" filterValues={this.props.filterValues} setFilterValues={this.props.setFilterValues}
                        filters={this.state.configurations}
                    />}
                <Col xs={12} className="mt-2">
                    <Row>
                        <Col>
                            <span className="driver-search-filter">
                                <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col className="mt-1 p-0">
                            <a id="viewFilters" className={`driver-list-button`} onClick={() => this.toggleModal("viewFilters")}>
                                <i className="fa fa-sliders fa-solid fa-2x" aria-hidden="true"></i>
                                {this.getFiltersLength()}
                            </a>
                        </Col>
                    </Row>
                </Col>
                {this.props.filterValues && <Col xs={12} className="mt-2 search-filter-container">
                    {Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).map(key =>
                        <span key={key} className="search-filter-preview">
                            <span>
                                <i className="fa fa-times-circle" onClick={() => this.removeFilter(this.state.configurations.find(setting => setting.name === key).name)}></i>&nbsp;&nbsp;
                                {this.state.configurations.find(setting => setting.name === key).title}
                            </span>
                            {this.getValueByFilterType(this.state.configurations.find(setting => setting.name === key), this.props.filterValues[key])}
                        </span>
                    )}
                </Col>}
            </Row>
        )
    }
}


export default (IncidentListHeader)
